import React, { useState, useEffect } from 'react';

// Components
import { DropdownV2 } from '@zola/zola-ui';
import RegistryOnboardControl from './RegistryOnboardControl/RegistryOnboardControl';
import {
  RegistryOnboardVariationTemplate,
  UniversalRegistrySection,
  ProductCategoriesSection,
  BrandsSection,
} from './components'; // TODO: dynamically import components

// Util
import { trackRecommendation } from '../../../../../../util/trackingHelper';
// import experimentFlags, { WEB_TO_REG } from '../../../../../../util/experimentFlags';

import styles from './RegistryOnboardContainer.module.less';

const RegistryOnboardContainer = (/* { userContext } */) => {
  const [variation, setVariation] = useState('TEST-3'); // for qa testing
  // const variation = experimentFlags.getExperimentVariation(WEB_TO_REG, userContext);

  useEffect(() => {
    trackRecommendation('Viewed', {
      recommendation_key: 'website_registry_empty_asset',
      recommendation_name: 'Website Registry Empty Asset',
      recommendation_copy: 'Website Registry Ipad Asset',
    });
  }, []);

  const renderVariation = () => {
    switch (variation) {
      case 'TEST-1':
        return <RegistryOnboardControl variant />;
      case 'TEST-2':
        return (
          <RegistryOnboardVariationTemplate>
            <UniversalRegistrySection />
          </RegistryOnboardVariationTemplate>
        );
      case 'TEST-3':
        return (
          <RegistryOnboardVariationTemplate>
            <ProductCategoriesSection />
          </RegistryOnboardVariationTemplate>
        );
      case 'TEST-4':
        return (
          <RegistryOnboardVariationTemplate>
            <BrandsSection />
          </RegistryOnboardVariationTemplate>
        );
      default:
        return <RegistryOnboardControl />;
    }
  };

  return (
    <div className={styles.container}>
      <DropdownV2
        options={[
          { label: 'Control', value: 'GREETING' },
          { label: 'Variation #1', value: 'TEST-1' },
          { label: 'Variation #2', value: 'TEST-2' },
          { label: 'Variation #3', value: 'TEST-3' },
          { label: 'Variation #4', value: 'TEST-4' },
        ]}
        placeholder="Please select one"
        label="Experiment Variation"
        onSelect={setVariation}
      />
      {renderVariation()}
    </div>
  );
};

export default RegistryOnboardContainer;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/RegistryContainer/RegistryOnboardContainer/RegistryOnboardContainer.jsx